module.exports = __webpack_public_path__ + "static/media/ethtzLogo.58e392d8.png";